import { makeStyles } from "@mui/styles";
const useExceptionStyles = makeStyles(() => {
  return {
    textLinkContainer: {
      position: "relative",

      "&.mobile": {
        textAlign: "center",
      },
    },

    amazonAccount: {
        fontFamily: "Lato",
        fontSize: "16px",
        color: "#FFFFFF !important",
        background: "linear-gradient(90deg, #034D80 0%, #2D97E1 100%)",
        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
        borderRadius: "4px",
        width: "332px",
        border: "none",
        marginTop: "23px",
        padding: "5px",
        textTransform: "none",
  
        "&.mobile": {
          width: "100%",
          marginTop: "20px",
        },
      },
      buttonsContainer: {
        display: "flex",
        flexDirection: "row",
        gap: "96px",
        marginTop: "20px",
        zIndex: "1",
  
        "&.mobile": {
          flexDirection: "column",
          gap: "10px",
        },
      },
  };
});

export default useExceptionStyles;
